export default __webpack_public_path__ + "static/s05-4bba82e693c6b9d61f1ba15a779f2e50.png";